import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { createSlice } from "@reduxjs/toolkit";
// export interface IglobalState {
// }
var initialState = {
    step1: {},
    step2: {},
    step3: {},
    step4: {}
};
export var globalSlice = createSlice({
    name: "globalState",
    initialState: initialState,
    reducers: {
        setGlobalState: function (state, action) {
            var _a;
            var _b = action.payload, key = _b.key, value = _b.value;
            return _objectSpread(_objectSpread({}, state), {}, (_a = {},
                _a[key] = value,
                _a));
        }
    }
});
export var setGlobalState = globalSlice.actions.setGlobalState;
export var globalStateReducer = globalSlice.reducer;
export default globalStateReducer;
